/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled';
import { spacing, typography } from '$variables/theme';
import COLORS from '$variables/colors';

export const Container = styled.div`
  margin-top: ${spacing.small};
  width: 100%;
`;

export const Button = styled.div`
  color: ${({ disabled }) => (disabled ? COLORS.grey1 : COLORS.green)};
  font-size: 14px;
  font-weight: ${typography.fontWeightMedium};

  width: 152px;
  padding: ${spacing.xSmall} 0;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  :hover {
    color: ${({ disabled }) => (disabled ? COLORS.grey1 : COLORS.greenLight)};
  }
`;
